<ng-container *ngIf="isBiometry; else commonHeader">
  <header class="header header-white header-bm">
    <div
      class="back-button-container"
      *ngIf="backButton.visible === true"
      (click)="goTo()"
      (keydown)="goTo()"
    >
      <span class="icon-previos"></span>
      <p>Volver</p>
    </div>
    <div class="logo-bm">
      <picture>
        <source
          type="image/svg+xml"
          media="(min-width: 600px)"
          [srcset]="assetsUrl + '/common/logo/logo-av-villas.svg'"
        />
        <img [src]="assetsUrl + '/common/logo/logo-av-villas.svg'" alt="logo" />
      </picture>
      <figure class="header-image"></figure>
    </div>
  </header>
</ng-container>

<ng-template #commonHeader>
  <header
    class="header container"
    [class]="headerLanding ? 'header-transparent' : 'header-white '"
  >
    <div class="logo">
      <picture *ngIf="whiteHeader">
        <source
          type="image/svg+xml"
          media="(min-width: 900px)"
          [srcset]="assetsUrl + '/images/cdt/logo/av-villas-logo-white.svg'"
        />
        <img
          [src]="assetsUrl + '/common/logo/logo-av-villas.svg'"
          alt="logo"
        />
      </picture>
      <div class="header-logo">
        <picture *ngIf="headerLanding">
          <img
            [src]="assetsUrl + '/common/logo/logo_av_villas_balloon.svg'"
            alt="logo"
          />
        </picture>
        <p *ngIf="headerLanding" class="together">● Juntos trabajando</p>
      </div>
      <picture *ngIf="!whiteHeader && !headerLanding">
        <img
          [src]="assetsUrl + '/common/logo/logo-av-villas.svg'"
          alt="logo"
        />
      </picture>
    </div>
  </header>
</ng-template>
